/**
 * Placeholder for an absent value in a table cell (e.g. no address, no
 * Organization number, an unrecognised Division). Shared by Customers (02),
 * Invites (03) and Requests (04) so the dash isn't declared once per cell.
 */
export const UNKNOWN_VALUE = '—';
